import PropTypes from 'prop-types';

import {getAuthorizationToken} from '@/src/app/utils/authorizationToken';
import PostCard from '@/src/Search/components/PostCard';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, Carousel, CourseCard, Text} from '@/src/ui';

import css from '../styles/MultipleSearchCourses.module.css';

const MultipleSearchCourses = ({coursesData, onShowCoursesClick, isPosts}) => {
  return (
    <div className={css.widget}>
      <div className={css.heading}>
        <Text
          color={Text.COLOR.PRIMARY}
          fontSize={Text.FONT_SIZE.SIZE_32}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
          fontFamily={Text.FONT_FAMILY.RUBIK}
        >
          <TextLocal id={isPosts ? 'general.topics' : 'general.courses'} />
        </Text>
      </div>

      {Boolean(coursesData) && isPosts && (
        <div className={css.postsList}>
          {coursesData.map((post) => (
            <PostCard
              {...post}
              isWatchCourse={Boolean(getAuthorizationToken())}
              key={post.id}
            />
          ))}
        </div>
      )}

      {Boolean(coursesData) && !isPosts && (
        <div className={css.coursesList}>
          <Carousel
            settings={{
              loop: false,
            }}
            navigationPosition={Carousel.NAVIGATION_POSITION.BOTTOM}
          >
            {coursesData.map((course) => (
              <div className={css.courseCard} key={course.id}>
                <CourseCard {...course} />
              </div>
            ))}
          </Carousel>
        </div>
      )}
      <div className={css.buttonBlock}>
        <Button
          color={Button.COLOR.SECONDARY}
          onClick={onShowCoursesClick}
          border={Button.BORDER.BOLD}
          height={Button.HEIGHT.SMALL}
        >
          <TextLocal id={'promoSection.see-all'} />
        </Button>
      </div>
    </div>
  );
};

MultipleSearchCourses.propTypes = {
  coursesData: PropTypes.array,
  onShowCoursesClick: PropTypes.func.isRequired,
};

export default MultipleSearchCourses;
